import {BackendResponse} from '@common/http/backend-response/backend-response';
import {apiClient} from '@common/http/query-client';
import {showHttpErrorToast} from '@common/http/show-http-error-toast';
import {useMutation} from '@tanstack/react-query';
import {
  getBootstrapData,
  mergeBootstrapData,
} from '@ui/bootstrap-data/bootstrap-data-store';
import {Localization} from '@ui/i18n/localization';

interface ChangeLocaleResponse extends BackendResponse {
  locale: Localization;
}

export function useChangeLocale() {
  return useMutation({
    mutationFn: (props: {locale?: string}) =>
      apiClient
        .post<ChangeLocaleResponse>(`users/me/locale`, props)
        .then(r => r.data),
    onSuccess: response => {
      // bootstrap only ships lines for the locale active at page load, so
      // take the lines of the newly selected locale from the response
      const locales = getBootstrapData().i18n.locales.map(locale =>
        locale.language === response.locale.language
          ? {...locale, lines: response.locale.lines ?? locale.lines}
          : locale,
      );
      mergeBootstrapData({
        i18n: {
          locales,
          active: response.locale.language,
        },
      });
    },
    onError: err => showHttpErrorToast(err),
  });
}
